import { Checkbox } from "@/components/Checkbox/Checkbox";
import { DialogBox } from "@/components/DialogBox/DialogBox";
import { getStorageValue, LOCAL_STORAGE_KEYS, setStorageValue } from "@/hooks/localstorage";
import { CaseState } from "@/store/slices/casesSlice";
import { RootState } from "@/store/store";
import { Beacon, PRODUCT_ISSUE_FEEDBACK_MESSAGE_ID } from "@/utils/beacon";
import { Box, Link, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const shouldAllowDialog = () => getStorageValue(LOCAL_STORAGE_KEYS.showBasedModelWarningPreference, true);

export const BasedModelUploadWarningDialog = () => {
  const { t } = useTranslation("cases");
  const [showDialog, setShowDialog] = useState(shouldAllowDialog);
  const [dontRemindMe, setDontRemindMe] = useState(false);
  const hasBasedModelInUploadDialog = useSelector(
    (state: RootState) =>
      Object.values(state.cases.cases).find(
        (caseData?: CaseState) =>
          caseData?.warnings?.find((issue) => issue.code === "basedModel") !== undefined ||
          caseData?.errors?.find((issue) => issue.code === "basedModel") !== undefined
      ) !== undefined
  );

  useEffect(() => {
    if (shouldAllowDialog()) {
      setShowDialog(true);
    }
  }, [hasBasedModelInUploadDialog]);

  const onClose = () => {
    setShowDialog(false);
    if (dontRemindMe) {
      setStorageValue(LOCAL_STORAGE_KEYS.showBasedModelWarningPreference, false);
    }
  };

  return (
    <DialogBox
      title={t("title.uploadRawScans")}
      message={
        <>
          <Typography sx={{ whiteSpace: "pre-wrap" }}>
            <Trans
              i18nKey={"message.basedModelsUploaded"}
              t={t}
              components={{
                a: (
                  <Link
                    component={"a"}
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      Beacon("show-message", PRODUCT_ISSUE_FEEDBACK_MESSAGE_ID, { force: true, delay: 0 });
                    }}
                  />
                )
              }}
            />
          </Typography>
          <br />
          <Box sx={{ display: "fex", alignItems: "center" }}>
            <Checkbox
              onChange={(_, checked) => {
                setDontRemindMe(checked);
              }}
            />
            <Typography>{t("label.dontRemindMe")}</Typography>
          </Box>
        </>
      }
      args={undefined}
      onClose={onClose}
      open={showDialog && hasBasedModelInUploadDialog}
      setOpen={setShowDialog}
      hideDecline
      confirmText={t("common:button.ok")}
    />
  );
};
